import React, { useEffect, useState } from 'react';
import { message } from 'antd';
import cccApi, { type CccLeadNote, type CccWorkspaceKind } from '../api/cccApi';

const formatDateTime = (iso?: string) => {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString('pt-PT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return iso;
  }
};

const emptyMessage = (workspace: CccWorkspaceKind) =>
  workspace === 'prospeccao'
    ? 'Ainda sem notas nesta lead.'
    : 'Ainda sem notas nesta marcação.';

type Props = {
  workspace: CccWorkspaceKind;
  entityId: string;
};

const CccClientNotesSection: React.FC<Props> = ({ workspace, entityId }) => {
  const [loading, setLoading] = useState(false);
  const [notes, setNotes] = useState<CccLeadNote[]>([]);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);

    cccApi
      .getCccDashboardClientNotes({ workspace, entity_id: entityId })
      .then((res) => {
        if (cancelled) return;
        setNotes(Array.isArray(res.notes) ? res.notes : []);
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        const msg =
          (err as { response?: { data?: { message?: string } } })?.response?.data?.message ||
          'Erro ao carregar notas';
        message.error(msg);
        setNotes([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [workspace, entityId]);

  return (
    <section className="rec-lead-notes ccc-client-notes-section">
      <h4 className="rec-lead-section-title">Notas</h4>
      {loading ? (
        <p className="rec-lead-notes-empty">A carregar notas…</p>
      ) : notes.length === 0 ? (
        <p className="rec-lead-notes-empty">{emptyMessage(workspace)}</p>
      ) : (
        <div className="rec-lead-notes-list">
          {[...notes].reverse().map((note, index) => (
            <article key={`${note.at}-${index}`} className="rec-lead-note-card">
              <p className="rec-lead-note-text">{note.text}</p>
              <footer className="rec-lead-note-meta">
                {note.by_name || 'Utilizador'} · {formatDateTime(note.at)}
              </footer>
            </article>
          ))}
        </div>
      )}
    </section>
  );
};

export default CccClientNotesSection;
